export enum IhmWarningMessageLevel {
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning'
}
